function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.72964 1.57572L5.30567 3.99995L7.72964 6.42405C8.09019 6.78474 8.09019 7.36901 7.72964 7.72971C7.54949 7.90986 7.3133 8 7.07722 8C6.84076 8 6.60455 7.90999 6.42453 7.72971L4.00004 5.30532L1.57572 7.72968C1.3956 7.90983 1.15938 7.99998 0.923104 7.99998C0.686892 7.99998 0.450841 7.90997 0.270553 7.72968C-0.0900005 7.36915 -0.0900005 6.78486 0.270553 6.42403L2.69445 3.99992L0.270415 1.57572C-0.0901383 1.21517 -0.0901383 0.630762 0.270415 0.270208C0.630899 -0.0900694 1.21496 -0.0900694 1.57559 0.270208L4.00001 2.69443L6.42426 0.270208C6.78495 -0.0900694 7.36908 -0.0900694 7.7295 0.270208C8.09019 0.630762 8.09019 1.21517 7.72964 1.57572Z",
  fill: "#A9AFBF"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.63dd63fc.svg";
export { ForwardRef as ReactComponent };